interface BottleIllustrationProps {
  label?: string;
  tint?: "light" | "dark";
  className?: string;
}

export default function BottleIllustration({
  label = "BP-01",
  tint = "light",
  className,
}: BottleIllustrationProps) {
  const bg = tint === "dark" ? "oklch(0.22 0.01 240)" : "var(--bp-bg)";
  const stroke = tint === "dark" ? "oklch(0.75 0.01 240)" : "var(--bp-ink)";
  return (
    <svg viewBox="0 0 120 180" className={className} style={{ width: "100%", height: "auto", display: "block" }}>
      <rect x="44" y="10" width="32" height="22" fill={stroke} />
      <rect x="50" y="32" width="20" height="10" fill="none" stroke={stroke} strokeWidth="1" />
      <rect x="28" y="42" width="64" height="128" fill={bg} stroke={stroke} strokeWidth="1" />
      <rect x="34" y="66" width="52" height="82" fill="none" stroke={stroke} strokeWidth="0.5" strokeDasharray="2 2" />
      <text x="40" y="84" fontFamily="var(--bp-mono)" fontSize="7" fill={stroke} letterSpacing="0.5">{label}</text>
      <line x1="40" y1="92" x2="80" y2="92" stroke={stroke} strokeWidth="0.5" />
      <text x="40" y="104" fontFamily="var(--bp-mono)" fontSize="5" fill={stroke} opacity="0.7">CLINICAL FORMULATION</text>
      <text x="40" y="112" fontFamily="var(--bp-mono)" fontSize="5" fill={stroke} opacity="0.7">WITH INTEGRITY.</text>
      <line x1="40" y1="122" x2="80" y2="122" stroke={stroke} strokeWidth="0.5" />
      <text x="40" y="134" fontFamily="var(--bp-mono)" fontSize="5" fill={stroke} opacity="0.7">30 ML · 1.0 FL. OZ.</text>
      <text x="40" y="142" fontFamily="var(--bp-mono)" fontSize="5" fill={stroke} opacity="0.7">LOT 240318·CH</text>
    </svg>
  );
}
